const alertCicle =
  'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/spot-alert-circle';
const cactusNeutral =
  'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/spot-cactus-neutral';
const xmCloud =
  'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/mark-xm_cloud';

export { alertCicle, cactusNeutral, xmCloud };
